// react
import React from 'react';

// types
import { DoctorAvailabilityData } from 'data-types';

// components
import DoctorCard from './DoctorCard';
import Skeletonize from '../../Skeletons/Skeletonize';

// Create placeholder doctor data for skeleton loading
const createPlaceholderDoctorData = (): DoctorAvailabilityData => ({
	availability: [],
	name: '',
	expertise: '',
	imageSrc: '',
	brief: '',
	doctorID: 0,
});


type Props = {
	language: string;
	doctorsAvailabilityData: DoctorAvailabilityData[];
	selectDoctorHandler: (doctor: DoctorAvailabilityData) => void;
	isLoading: boolean;
	layoutWithDoctors: boolean;
}

const DoctorsList: React.FC<Props> = ({ language, doctorsAvailabilityData, selectDoctorHandler, isLoading, layoutWithDoctors }) => {

	const componentFactory = (key: React.Key, isLoading: boolean) => (
		<DoctorCard 
			key={key}
			language={language}
			doctorAvailabilityData={createPlaceholderDoctorData()} 
			onDoctorCardClick={selectDoctorHandler}
			isLoading={isLoading}
			layoutWithDoctors={layoutWithDoctors}
		/>
	)

	return (
		<div 
			id="select-doctor-container"
			className="
				grid
				gap-[20px] 
                md:grid-cols-[repeat(auto-fill,minmax(max(calc((100%_-_40px)/3),330px),1fr))]
				grid-cols-[1fr]
			"
		>
			<Skeletonize
				isLoading={isLoading}
				skeletonCount={6}
				componentFactory={componentFactory}
			>
				{({ disableSkeleton, isLoading }) => 
					doctorsAvailabilityData.map((doctorAvailabilityData, index) => (
						<DoctorCard 
							key={index} 
							language={language}
							doctorAvailabilityData={doctorAvailabilityData} 
							onDoctorCardClick={selectDoctorHandler}
							isLoading={isLoading}
							disableSkeleton={disableSkeleton}
							layoutWithDoctors={layoutWithDoctors}
						/>
					))
				}
			</Skeletonize>
		</div>
	);
}

export default DoctorsList;